import { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFeatureFlag } from 'modules/common/hooks';

export const useApplyProgress = (isProcessing: boolean): number => {
  const isBetterUxEnabled = useFeatureFlag('isSmartDiaryBetterUxEnabled');
  const isPerformanceFixEnabled = useFeatureFlag(
    'isSmartTimesheetPerformanceEnabled'
  );
  const [progress, setProgress] = useState(0);
  const { getValues } = useFormContext();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isBetterUxEnabled && isProcessing) {
      const totalCount =
        Object.values(getValues()).filter((v) => v).length || 0;
      // logic to calculate approximate progress
      const delay = Math.min(
        0.15 + totalCount * (isPerformanceFixEnabled ? 0.01 : 0.015),
        2
      );
      timer = setInterval(() => {
        setProgress((val) => (val <= 90 ? val + 5 : val));
      }, delay * 1000);
    } else {
      setProgress(0);
    }

    return () => {
      clearInterval(timer);
    };
  }, [getValues, isBetterUxEnabled, isPerformanceFixEnabled, isProcessing]);

  return progress;
};
